import { Grid } from "@mui/material";
import React from "react";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../../../models/session/sessionState";
import { FormAccordion } from "source/components/framework/FormAccordion";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { IAppReportTemplateFormModel } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateFormModel";
import { FormDesignBuilderDroppableId, FormDesignerDataRow } from "source/components/task/TaskTypeDialog/FormDesignerTypes";
import { FormDesignerBuilderFormBuilder } from "source/components/task/TaskTypeDialog/TaskTypeDialogFormDesigner/FormDesignerBuilder/FormDesignerBuilderFormBuilder";

interface IReportDesignerBuilderProps {
    appReportTemplate?: IAppReportTemplateFormModel;
    formDesignerRows?: FormDesignerDataRow[];
    formDataRow?: ITaskDataRow;
    formTypeCol: ITaskTypeCol;
    sessionState: ISessionState;
    draggingWidth?: number;
    draggingSource?: string;
    onFormItemClick?: (id: string) => void;
    onFormRemoveComponent: (id: string) => void;
    onFormCopyComponent: (id: string) => void;
    onViewSchema: () => void;
}

export const ReportDesignerBuilder = (props: IReportDesignerBuilderProps) => {
    return (
        <DialogSectionCard
            width="100%"
            headerTitle={Translations.DesignArea}
            buttons={props.sessionState?.isSuperAdmin
                ? <AppButton size="small" variant="outlined" onClick={props.onViewSchema}>{Translations.ShowSchema}</AppButton>
                : null
            }
            contentPadding="16px 0!important"
        >
            <Grid sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 350px)",
                paddingLeft: "0",
                paddingRight: "0"
            }}>
                <FormAccordion
                    defaultExpanded={true}
                    title={Translations.Contents}
                >
                    <FormDesignerBuilderFormBuilder
                        droppableId={FormDesignBuilderDroppableId.Form}
                        pickerDroppableId={FormDesignBuilderDroppableId.Picker}
                        designerRows={props.formDesignerRows}
                        taskDataRow={props.formDataRow}
                        taskTypeCol={props.formTypeCol}
                        taskTypeCols={props.appReportTemplate?.formCols ?? []}
                        draggingWidth={props.draggingWidth}
                        draggingSource={props.draggingSource}
                        onClick={props.onFormItemClick}
                        onRemoveComponent={props.onFormRemoveComponent}
                        onCopyComponent={props.onFormCopyComponent}
                    />
                </FormAccordion>
            </Grid>
        </DialogSectionCard>
    );
};
